var _path, _rect, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWordIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9838 0H5.03488C4.30259 0 3.70752 0.599733 3.70752 1.3416V22.6584C3.70752 23.3995 4.30259 24 5.03488 24H20.9666C21.7005 24 22.294 23.3995 22.294 22.6584V5.3664L16.9838 0ZM16.9838 1.8968L20.4172 5.3664H16.9838V1.8968ZM20.9669 22.6584H5.03488V1.3416H15.6561V5.3664C15.6561 6.10747 16.2499 6.708 16.9835 6.708H20.9666L20.9669 22.6584Z",
    fill: "#1C5FBE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.25,
    y: 4.125,
    width: 12,
    height: 15.75,
    rx: 0.875,
    fill: "#1C5FBE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.11342 15.375L8.37749 11.7832L9.63609 15.375H10.9111L12.7498 10.125H11.5951L10.2763 14.0949L8.95207 10.125H7.79744L6.47865 14.0949L5.15986 10.125H3.99976L5.83841 15.375H7.11342Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWordIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/word-icon.1394bd94c5ccc0788d6a4d9cada1abd6.svg";